import { AdTabProps } from "./tab";

enum AdTabsEnum {
  RGCams="RGCams",
  LiveSex="LiveSex",
  SexGames="SexGames",
}

type AdTabsProps = {
  [name in AdTabsEnum]: AdTabProps;
}

export const tabs: AdTabsProps = {
  [AdTabsEnum.RGCams]: {
    label: "RGCams",
    link: "https://bit.ly/3CRhea4",
  },
  [AdTabsEnum.LiveSex]: {
    label: "Live Sex ",
    link: "https://bit.ly/3q5TlIg",
  },
  [AdTabsEnum.SexGames]: {
    label: "Sex Games ",
    link: "https://bit.ly/3Ib5Zw3",
  }
};
